import styled, { css } from 'styled-components';
import {
  COLOR_TEXT_PRIMARY as COLOR_PRIMARY,
  COLOR_TEXT_SECONDARY as COLOR_SECONDARY,
} from '../colors/colors';

const titleVariantStyles = {
  normal: css`
    font-size: 18px;
    font-weight: normal;
    line-height: 1.4;
  `,
  bold: css`
    font-size: 24px;
    font-weight: 700;
    line-height: 1.3;
  `,
};

export const YouTitle = styled.h1`
  text-align: center;
  width: 100%;
  margin: 0;
  max-width: 420px;
  align-self: center;
  color: ${COLOR_PRIMARY};
  ${({ $variant = 'normal' }) =>
    titleVariantStyles[$variant] || titleVariantStyles.normal}
`;

const subtitleVariantStyles = {
  normal: css`
    font-size: 14px;
    margin-top: 4px;
    line-height: 1.4;
  `,
  description: css`
    font-size: 16px;
    margin: 0;
    line-height: 1.4;
  `,
};

export const YouSubtitle = styled.p`
  text-align: center;
  width: 100%;
  max-width: 420px;
  align-self: center;
  font-weight: normal;
  color: ${COLOR_SECONDARY};
  ${({ $variant = 'normal' }) =>
    subtitleVariantStyles[$variant] || subtitleVariantStyles.normal}
`;

export const YouContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 16px 0 16px;
  box-sizing: border-box;
  max-width: 420px;
  margin: auto;
`;

export const YouCenteredContentArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 420px;
  gap: 16px;
  padding-bottom: 16px;
`;

export const YouStatusIcon = styled.img`
  width: 64px;
  height: 64px;
  display: block;
`;
